import { useEffect, useRef, useState } from 'react';
import { useImageLazyLoading } from './ImageLazyLoadingProvider';

export function useIsLazyLoaded(imageId) {
  const [lazyLoaded, setLazyLoaded] = useState(false);
  const { setupImageLazyLoading } = useImageLazyLoading();
  const lazyLoadImageRef = useRef(() => {
    setLazyLoaded(true);
  });

  useEffect(() => {
    setupImageLazyLoading(imageId, lazyLoadImageRef);
  }, [imageId]);

  return lazyLoaded;
}
